// extracted by mini-css-extract-plugin
module.exports = {"nextStepBtn":"flights-list_nextStepBtn__15S0p","tableContainer":"flights-list_tableContainer__I7DRl"};